import React from "react";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import TextImage from "./TextImage";

import { hasCategoryType, hasShades, hasSingleSideColor } from "../helpers";

const useStyles = makeStyles(theme => ({
  container: {
    overflowX: "auto",
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      overflowX: "hidden",
      overflow: "hidden"
    }
  },
  headCell: {
    fontWeight: "700"
  }
}));

function SummaryTable({
  count,
  material,
  product,
  selectedShades,
  system,
  type,
  color,
  colorInterior,
  colorExterior,
  width,
  height
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <div style={{ position: "relative" }} className={classes.container}>
        <Table aria-label="summary table">
          <TableBody>
            <TableRow key="product">
              <TableCell
                className={classes.headCell}
                component="th"
                scope="row"
              >
                {t("categories.product")}:
              </TableCell>
              <TableCell align="right">
                {t(`names.products.${product.name}`)}
              </TableCell>
            </TableRow>
            <TableRow key="product">
              <TableCell
                className={classes.headCell}
                component="th"
                scope="row"
              >
                {t(
                  `categories.${
                    hasCategoryType([{ type: material.type }])
                      ? "category"
                      : "material"
                  }`
                )}
                :
              </TableCell>
              <TableCell align="right">
                {t(`names.materials.${material.name}`)}
              </TableCell>
            </TableRow>
            <TableRow key="count">
              <TableCell
                className={classes.headCell}
                component="th"
                scope="row"
              >
                {t("categories.count")}:
              </TableCell>
              <TableCell align="right">{count}</TableCell>
            </TableRow>
            <TableRow key="system">
              <TableCell
                className={classes.headCell}
                component="th"
                scope="row"
              >
                {t("categories.system")}:
              </TableCell>
              <TableCell align="right">
                {t(`names.systems.${system.name}`)}
              </TableCell>
            </TableRow>
            <TableRow key="type">
              <TableCell
                className={classes.headCell}
                component="th"
                scope="row"
              >
                {t("categories.type")}:
              </TableCell>
              <TableCell align="right">
                <TextImage
                  image={type.image}
                  text={t(
                    `names.${type.isSubtype ? "subtypes" : "types"}.${
                      type.name
                    }`
                  )}
                />
              </TableCell>
            </TableRow>
            {hasSingleSideColor(product.id) ? (
              <TableRow key="color">
                <TableCell
                  className={classes.headCell}
                  component="th"
                  scope="row"
                >
                  {t("categories.color")}:
                </TableCell>
                <TableCell align="right">
                  {t(`names.colors.${color.name}`)}
                </TableCell>
              </TableRow>
            ) : (
              <>
                <TableRow key="colorInterior">
                  <TableCell
                    className={classes.headCell}
                    component="th"
                    scope="row"
                  >
                    {t("categories.color interior")}:
                  </TableCell>
                  <TableCell align="right">
                    {t(`names.colors.${colorInterior.name}`)}
                  </TableCell>
                </TableRow>
                <TableRow key="colorExterior">
                  <TableCell
                    className={classes.headCell}
                    component="th"
                    scope="row"
                  >
                    {t("categories.color exterior")}:
                  </TableCell>
                  <TableCell align="right">
                    {t(`names.colors.${colorExterior.name}`)}
                  </TableCell>
                </TableRow>
              </>
            )}
            <TableRow key="dimensions">
              <TableCell
                className={classes.headCell}
                component="th"
                scope="row"
              >
                {t("categories.dimensions")}:
              </TableCell>
              <TableCell align="right">
                {width} x {height}
              </TableCell>
            </TableRow>
            {hasShades(product.id) ? (
              <TableRow key="shades">
                <TableCell
                  className={classes.headCell}
                  component="th"
                  scope="row"
                >
                  {t("categories.shades")}:
                </TableCell>
                <TableCell align="right">
                  {selectedShades ? t("root.yes") : t("root.no")}
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </div>
    </TableContainer>
  );
}

export default SummaryTable;
